import { render, staticRenderFns } from "./Database.vue?vue&type=template&id=d330282e&"
import script from "./Database.vue?vue&type=script&lang=ts&"
export * from "./Database.vue?vue&type=script&lang=ts&"
import style0 from "./Database.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports